// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__pqdxn","homeLink":"NotFound_homeLink__lLlJl"};